<div class="main-wrap" [ngClass]="{ 'main-wrap--no-sidebar': hideSidebar }">
    <app-sidebar class="sidebarview" *ngIf="!hideSidebar"></app-sidebar>
    <section class="section commontopheight">
        <app-contract-transactions [isView]="isView"></app-contract-transactions>
        <router-outlet></router-outlet>
    </section>
</div>


